import { Controller } from '@hotwired/stimulus';
import { getRequest } from '../src/utils';

export default class extends Controller {
  static targets = ['postalCode', 'errorMessage'];

  connect() {
    console.log('geolocator controller connected');
  }

  async fetchAddress() {
    const postalCode = this.postalCodeTarget.value;

    if (postalCode) {
      try {
        const resp = await getRequest(`/api/v1/schools/fetch_address?postal_code=${postalCode}`);
        const data = await resp.json();
        console.log('Address data:', data);
        if (data.address) {
          // Find the address and country inputs by their labels or IDs
          const addressInput = document.querySelector("input[name='school[address]']");
          const countryDropdown = document.querySelector("select[name='school[country]']");

          if (addressInput) {
            addressInput.value = data.address;
            this.flashBorder(addressInput);
          }

          if (countryDropdown) {
            countryDropdown.value = data.country;
            const event = new Event('change', { bubbles: true });
            countryDropdown.dispatchEvent(event);
            this.flashBorder(countryDropdown);

            // Manually update the Select2 display
            const select2Container = document.querySelector(`#select2-${countryDropdown.id}-container`);
            if (select2Container) {
              const selectedOption = countryDropdown.options[countryDropdown.selectedIndex].text;
              select2Container.textContent = selectedOption;
              select2Container.title = selectedOption;
            }
            this.errorMessageTarget.classList.add('hidden');
          }
        } else {
          console.error('Address not found:', data.error);
          this.errorMessageTarget.classList.remove('hidden');
        }
      } catch (error) {
        console.error('Error fetching address:', error);
        this.errorMessageTarget.classList.remove('hidden');
      }
    }
  }

  flashBorder(element) {
    element.classList.add('flash-border', 'animate-pulse');
    setTimeout(() => {
      element.classList.remove('flash-border', 'animate-pulse');
    }, 1500); // Duration of the flashing effect
  }
}
